import { render, staticRenderFns } from "./product2.vue?vue&type=template&id=e7edb38a&scoped=true&"
import script from "./product2.vue?vue&type=script&lang=js&"
export * from "./product2.vue?vue&type=script&lang=js&"
import style0 from "./product2.vue?vue&type=style&index=0&id=e7edb38a&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7edb38a",
  null
  
)

export default component.exports